import { Select } from 'antd'
import React from 'react'
import { useUserOptions } from 'hooks/api'

const { Option } = Select

export const UserSelectField = (props) => {
    const { HandleUserChange, onChange, value, size = "medium", style = {}, users, className } = props
    // Self-fetch the lightweight, cached user options when no explicit list is provided.
    const { data: userOptions = [] } = useUserOptions({ enabled: users === undefined });

    const displayList = users ?? userOptions;
    const triggerChange = HandleUserChange || onChange;

    return (
        <Select
            showSearch
            size={size}
            placeholder="Select User"
            value={value}
            style={{ minWidth: 180, width: "100%", ...style }}
            className={className}
            onChange={(value) => triggerChange && triggerChange(value)}
            optionFilterProp="label"
            filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            allowClear
        >
            {
                displayList?.length > 0 ?
                    displayList.map((item, index) => {
                        const label = `${item?.company_name ?? ''} ${item?.name ?? ''}`.trim();
                        return (
                            <Option value={item.id} key={index + 1} label={label}>
                                <span>{item?.company_name}</span>
                                {item?.name ? (
                                    <span style={{ color: '#9ca3af', marginLeft: 4 }}>({item.name})</span>
                                ) : null}
                            </Option>
                        );
                    })
                    : null
            }
        </Select>
    )
}
